// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-html-elements-animated-js": () => import("./../src/pages/html-elements-animated.js" /* webpackChunkName: "component---src-pages-html-elements-animated-js" */),
  "component---src-pages-html-elements-index-js": () => import("./../src/pages/html-elements/index.js" /* webpackChunkName: "component---src-pages-html-elements-index-js" */),
  "component---src-pages-html-elements-keyboard-jsx": () => import("./../src/pages/html-elements/Keyboard.jsx" /* webpackChunkName: "component---src-pages-html-elements-keyboard-jsx" */),
  "component---src-pages-html-elements-keycap-jsx": () => import("./../src/pages/html-elements/Keycap.jsx" /* webpackChunkName: "component---src-pages-html-elements-keycap-jsx" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

